/** Matches backend OtherInformation.InformationType display names — used as chart edge labels from Findings. */
export const FINDING_TYPE_EDGE_LABEL = {
  OPERATING_COMPANY: 'Operating Company',
  CONTACT_DETAILS: 'Contact Details',
  RELATED_DOMAIN: 'Related Domain',
  NETWORK_TRAFFIC: 'Network Traffic',
  SOURCE_CODES: 'Source Codes',
  LINKS: 'Links',
  CUSTOM: 'Custom',
};

/** User-visible heading for Finding rows/filters including one-off CUSTOM text. */
export function resolveFindingCategoryHeading(finding) {
  if (!finding?.informationType) return '';
  if (finding.informationType === 'CUSTOM') {
    const c = finding.customCategory != null ? String(finding.customCategory).trim() : '';
    return c || FINDING_TYPE_EDGE_LABEL.CUSTOM;
  }
  return FINDING_TYPE_EDGE_LABEL[finding.informationType] || finding.informationType.replace(/_/g, ' ');
}

/** Label sent as investigation connection_label when adding from Findings. */
export function connectionLabelFromFindingRow(finding) {
  return resolveFindingCategoryHeading(finding);
}
